module.exports = __webpack_public_path__ + "assets/img/index-2.557786f6.png";